module.exports = __webpack_public_path__ + "static/img/third2_1_7.f25fdf16.jpg";